import { JetCardMain } from './JetCard.style';
import Header from './components/Header';
import Content from './components/Content';
import Footer from 'components/layout/Footer';
import HeaderMeta from 'components/headerMeta/HeaderMeta';

const JetCard = () => {
  return (
    <JetCardMain>
      <HeaderMeta type="jetCard" />
      <Header />
      <Content />
      <Footer />
    </JetCardMain>
  );
};
export default JetCard;
